import { t } from "i18next";
import * as z from "zod";

import { PROVIDER_STATUSES, PROVIDER_TYPES } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire d'un provider
 * (`POST /Providers/add` / `PUT /Providers/{id}`, guide §6.4).
 *
 * Factory (règle projet) : créé via `createProviderSchema()` et mémoïsé
 * au niveau composant sur la langue courante.
 */
export const createProviderSchema = () =>
  z.object({
    code: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    name: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    type: z.enum(PROVIDER_TYPES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    status: z.enum(PROVIDER_STATUSES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
  });

export type ProviderFormValues = z.infer<
  ReturnType<typeof createProviderSchema>
>;
